/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ExternalAdUnitResource} from '../../components/api/resources/resource/externaladunit.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-external-ad-unit-route-page',
  template: `
    <adn-external-ad-unit-list-page
      *ngIf="list"
      [list]="list">
    </adn-external-ad-unit-list-page>
  `
})
export class ExternalAdUnitRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ExternalAdUnitResource) private readonly ExternalAdUnit: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.axPublisher.apiKey);
    this.adnListHelper.setUpList(this.list, this.ExternalAdUnit, readOnly, 'fullExternalAdUnitList', {
      baseTable: 'externalAdUnit'
    });
  }
}
